export class ViewContractComplianceIssue {
	public contractId: string;
	public missingContract: boolean;
	public missingBillCopy: boolean;
	public missingLOA: boolean;
	public marginAboveAverage: boolean;
	public quoteDateDiffFromRateAddDate: boolean;
	public noRateAddDate: boolean;
	public ocrResultNotReady: boolean;
	public billCopyOlderThan24h: boolean;
	public billCopyNeedsManualCheck: boolean;
	public receivedContractPages: number;
	public contractAttachmentCount: number;
	public expectedContractPages: number;
	public issues: Array<{ key: string; label: string }>;

	constructor(data: any = {}) {
		Object.assign(this, data);
	}
}
